import React, { useEffect, useState } from 'react'
import LeftSideMenu from '../components/LeftSideMenu'
import UserNav from '../components/UserNav'
import Loader from '../components/Loader'
import { useSelector } from 'react-redux'
import { useCreateBlogMutation, useListBlogsByUsernameQuery } from '../slices/blogsApiSlice'
import { Link } from 'react-router-dom'
import axios from 'axios'

const Blog = () => {

    const [pageLoad, setPageLoad] = useState(true)
    const { userInfo } = useSelector((state) => state.auth)

    const [title, setTitle] = useState('')
    const [slug, setSlug] = useState('')
    const [content, setContent] = useState('')
    const [featuredImageUrl, setFeaturedImageUrl] = useState('')
    const [featuredPreview, setFeaturedPreview] = useState('')
    const [isUploadingImage, setIsUploadingImage] = useState(false)
    const [metaTitle, setMetaTitle] = useState('')
    const [metaDescription, setMetaDescription] = useState('')
    const [metaKeywords, setMetaKeywords] = useState('')
    const [ogTitle, setOgTitle] = useState('')
    const [ogDescription, setOgDescription] = useState('')
    const [ogImage, setOgImage] = useState('')
    const [showAdvanced, setShowAdvanced] = useState(false)

    const [createBlog, { isLoading: isCreating }] = useCreateBlogMutation()
    const { data: blogs = [], isLoading: isListing } = useListBlogsByUsernameQuery(userInfo?.username, { skip: !userInfo?.username })

    useEffect(() => {
        const timeout = setTimeout(() => {
            setPageLoad(false)
        }, 1000);
        return () => clearTimeout(timeout)
    },[])

    if(pageLoad) {
        return (
            <Loader />
        )
    }

    return (
        <>
            <div className='pagecontent'>
                <LeftSideMenu />
                <div className='pagecontentbox'>
                    <div className="card" style={{ padding: 16, marginBottom: 24 }}>
                        <h4 className="mb-3">Add New Post</h4>
                        <form onSubmit={async (e) => {
                            e.preventDefault()
                            if (!title || !slug || !content) return
                            try {
                                await createBlog({
                                    title,
                                    slug,
                                    content,
                                    featuredImageUrl,
                                    metaTitle,
                                    metaDescription,
                                    metaKeywords: metaKeywords
                                      .split(',')
                                      .map((k) => k.trim())
                                      .filter(Boolean),
                                    ogTitle,
                                    ogDescription,
                                    ogImage,
                                }).unwrap()
                                setTitle('')
                                setSlug('')
                                setContent('')
                                setFeaturedImageUrl('')
                                setMetaTitle('')
                                setMetaDescription('')
                                setMetaKeywords('')
                                setOgTitle('')
                                setOgDescription('')
                                setOgImage('')
                            } catch (err) {
                                // no-op; could show a toast
                            }
                        }}>
                            <div className="mb-3">
                                <label className="form-label">Title</label>
                                <input className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="My first post" />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Slug</label>
                                <input className="form-control" value={slug} onChange={(e) => setSlug(e.target.value)} placeholder="my-first-post" />
                                <div className="form-text">URL: /{userInfo?.username || 'username'}/blog/{slug || 'my-first-post'}</div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Content</label>
                                <textarea className="form-control" rows={8} value={content} onChange={(e) => setContent(e.target.value)} placeholder="Write your post..." />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Featured Image</label>
                                <div className="d-flex align-items-center gap-3 mb-2">
                                    {featuredPreview || featuredImageUrl ? (
                                        <img src={featuredPreview || featuredImageUrl} alt="featured preview" style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: 8 }} />
                                    ) : null}
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={async (e) => {
                                            const file = e.target.files && e.target.files[0]
                                            if (!file) return
                                            setFeaturedPreview(URL.createObjectURL(file))
                                            setIsUploadingImage(true)
                                            try {
                                                const fd = new FormData()
                                                fd.append('file', file)
                                                fd.append('upload_preset', 'ml_default')
                                                fd.append('folder', 'blog_images')
                                                const res = await axios.post('https://api.cloudinary.com/v1_1/do2pizjsh/image/upload', fd)
                                                setFeaturedImageUrl(res.data.secure_url)
                                            } catch (err) {
                                                // ignore
                                            } finally {
                                                setIsUploadingImage(false)
                                            }
                                        }}
                                    />
                                </div>
                                {isUploadingImage && <small className="text-muted">Uploading image...</small>}
                            </div>
                            <div className="d-flex justify-content-end mb-2">
                                <button type="button" className="btn btn-link" onClick={() => setShowAdvanced((v) => !v)}>
                                    {showAdvanced ? 'Hide advanced' : 'Show advanced'}
                                </button>
                            </div>
                            {showAdvanced && (
                                <div style={{ overflowX: 'auto', paddingBottom: 8 }}>
                                    <div style={{ display: 'flex', gap: 16, minWidth: 600 }}>
                                        <div className="card" style={{ minWidth: 320, padding: 16 }}>
                                            <h5 className="mb-3">Meta</h5>
                                            <div className="mb-3">
                                                <label className="form-label">Meta Title</label>
                                                <input className="form-control" value={metaTitle} onChange={(e) => setMetaTitle(e.target.value)} placeholder="Custom SEO title" />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Meta Description</label>
                                                <textarea className="form-control" rows={2} value={metaDescription} onChange={(e) => setMetaDescription(e.target.value)} placeholder="Short SEO description" />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">Meta Keywords (comma separated)</label>
                                                <input className="form-control" value={metaKeywords} onChange={(e) => setMetaKeywords(e.target.value)} placeholder="keyword1, keyword2" />
                                            </div>
                                        </div>
                                        <div className="card" style={{ minWidth: 320, padding: 16 }}>
                                            <h5 className="mb-3">Open Graph</h5>
                                            <div className="mb-3">
                                                <label className="form-label">OG Title</label>
                                                <input className="form-control" value={ogTitle} onChange={(e) => setOgTitle(e.target.value)} placeholder="Open Graph title" />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">OG Description</label>
                                                <textarea className="form-control" rows={2} value={ogDescription} onChange={(e) => setOgDescription(e.target.value)} placeholder="Open Graph description" />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label">OG Image URL</label>
                                                <input className="form-control" value={ogImage} onChange={(e) => setOgImage(e.target.value)} placeholder="https://.../image.jpg" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <button className="btn btn-primary" type="submit" disabled={isCreating}>Create Post</button>
                        </form>
                    </div>

                    <div className="card" style={{ padding: 16 }}>
                        <h4 className="mb-3">Your Posts</h4>
                        {isListing ? (
                            <Loader />
                        ) : (
                            <ul className="list-group">
                                {blogs.length === 0 && <li className="list-group-item">No posts yet</li>}
                                {blogs.map((b) => (
                                    <li key={b._id} className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>
                                            {b.featuredImageUrl ? (
                                                <img src={b.featuredImageUrl} alt="thumb" style={{ width: 40, height: 40, objectFit: 'cover', marginRight: 8, borderRadius: 4 }} />
                                            ) : null}
                                            {b.title}
                                        </span>
                                        <Link className="btn btn-sm btn-outline-secondary" to={`/${userInfo?.username}/blog/${b.slug}`}>View</Link>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Blog